import { removeIn, setIn } from 'immutable';
export function createHistoryMaintenanceRedux(device_maintenances, new_maintenance) {
    if (device_maintenances == null) {
        return { history: [new_maintenance], planned_notification: null };
    }
    return setIn(device_maintenances, ['history'], [...device_maintenances.history, new_maintenance]);
}
export function findHistoryMaintenanceIndex(device_maintenances, search_maintenance) {
    const id = typeof search_maintenance === 'object'
        ? search_maintenance.id
        : search_maintenance;
    return device_maintenances.history.findIndex((hm) => hm.id === id);
}
export function deleteHistoryMaintenanceRedux(device_maintenances, deleted_maintenance_id) {
    if (device_maintenances == null) {
        return null;
    }
    return removeIn(device_maintenances, [
        'history',
        findHistoryMaintenanceIndex(device_maintenances, deleted_maintenance_id),
    ]);
}
export function editHistoryMaintenanceRedux(device_maintenances, edited_maintenances) {
    if (device_maintenances == null) {
        return null;
    }
    const index = findHistoryMaintenanceIndex(device_maintenances, edited_maintenances);
    return setIn(device_maintenances, ['history'], [
        ...device_maintenances.history.slice(0, index),
        edited_maintenances,
        ...device_maintenances.history.slice(index + 1),
    ]);
}
